export default {

    "Complexity Coverage": {
        "description": `Starting with your most complex jobs and working
                        towards your least complex, this slider allows you
                        to specify the amount of relative complexity you
                        plan to cover by your project's testing regime.
                        Often the very simplest jobs do not require you to
                        manually tweak the MettleCI automated Unit Tests.`,
        "default": "100%"
    },

    "Consultant Job Velocity": {
        "description": `This slider allows you to specify the amount of work
                        achievable by a single consultant within a single
                        sprint. In practical terms, this is the number of
                        MettleCI automated Unit Tests that can be enhanced to
                        'acceptable' status by one person in 1 week.`,
        "default": "80"
    },

    "Consultant Sequence Velocity": {
        "description": `This checkbox and slider allows you to specify whether
                        time should be included for the remediation of migrated
                        Job Sequences. Whether or not this is included will be
                        determined largely by the type, and complexity, of
                        activities included in your Job Sequences.`,
        "default": "80"
    },

    "On-shore Consultants": {
        "description": `This slider allows you to specify the number of
                        consultants assigned full-time to the task of enhancing
                        MettleCI automated Unit Tests.
        
                        Note that the current calculation makes no distinction
                        between onshore and offshore consultants.`,
        "default": "2"
    },

    "Off-shore Consultants": {
        "description": `This slider allows you to specify the number of
                        consultants assigned full-time to the task of enhancing
                        MettleCI automated Unit Tests.
        
                        Note that the current calculation makes no distinction
                        between onshore and offshore consultants.`,
        "default": "0"
    },

    "Optional Addons": {
        "description": `Optional Addons are additional optional work items
                        that can be added to the estimate as required.`
    },

    "Target Environment Installs": {
        "description": `This slider allows you to specify whether time should
                        be included for the installation of new Information
                        Server (DataStage) environments. Remember to consider
                        Dev, QA, and Prod requirements.`,
        "default": "0"
    },

    "Customer Functional Testing Sprints": {
        "description": `This slider allows you to specify whether additional
                        time should be included for the customer to perform
                        functional testing.`,
        "default": "0"
    },

    "Production Go-live Support Sprints": {
        "description": `This slider allows you to specify whether time should
                        be included for pre-go-live customer support, perhaps
                        by assisting with functional testing.  If included, this
                        is rarely more than a single sprint.`,
        "default": "0"
    },

    "Post Go-live Support Sprints": {
        "description": `This slider allows you to specify whether time should
                        be included for post go-live customer remediation. If
                        included, this is rarely more than a single sprint.`,
        "default": "0"
    },

    "Install MettleCI": {
        "description": `Select this checkbox if you need to include effort for
                        the installation of MettleCI platform.`
    },

    "Sprint List": {
        "description": `This lists the suggested sprints for your project, and
                        the focus of each sprint. The ellipsis (...) at the end
                        indicates that further sprints may be required, should
                        earlier sprints reveal new information about the
                        project assets, environment, or team constraints.`
    },

    "Project Complexity Tested": {
        "description": `Starting with your most complex jobs and working
                        towards your least complex, this describes the amount
                        of relative complexity you'll effectively test during
                        your project. Often the very simplest jobs do not
                        require you to manually tweak the MettIeCl automated
                        Unit Tests.`
    },

    "Unique Job Patterns": {
        "description": `Projects feature jobs which follow the same design,
                        with the only difference being metadata. This is the
                        number of unique 'patterns' observed in your project,
                        and will likely be lower than the number of jobs. We
                        aim to only test one instance of each pattern, as
                        testing further implementations of the same code is
                        often redundant.`
    },

    "Consultants": {
        "description": `The total number of on-shore and off-shore consultants
                        assigned to the project.`
    },

    "Months' Subscription": {
        "description": `Given the number of sprints calculated, this is the
                        recommended minimum number of months' subscription
                        required to the Rapid DataStage Upgrade offering.`
    }

};
